var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject } from 'mobx-react';
import { PositionType } from 'uitk-react-menu';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { HeaderImageToolbar } from '../../header-image-toolbar';
import { HeaderMenu } from './header-menu';
import { HeaderAccountMenu } from '../..';
var HeaderMinimalToolbar = /** @class */ (function (_super) {
    __extends(HeaderMinimalToolbar, _super);
    function HeaderMinimalToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderMinimalToolbar.prototype.render = function () {
        var _a = this.props, globalComponentsContext = _a.globalComponentsContext, analytics = _a.analytics, page = _a.page;
        var l10n = globalComponentsContext.header.l10n;
        var accountMenu = false;
        var accountMenuItem = null;
        var createMenuItems = function (prev, current) {
            if (current && current.type === 'link') {
                var menuItems_1 = {
                    className: 'uitk-list-item menu-Item',
                    label: current.text,
                    href: current.url,
                    typeAnchor: true,
                    attributes: {
                        role: 'menuItem',
                        tabindex: 0
                    }
                };
                prev.push(menuItems_1);
            }
            else if (current && current.type === 'menu') {
                if (current.id === 'memberProfileGuest' || current.id === 'memberProfileSignedIn') {
                    accountMenu = true;
                    accountMenuItem = current;
                }
            }
            return prev;
        };
        var _b = this.props, headerData = _b.headerData, languages = _b.languages;
        var navLinkMenuItems = (headerData
            && headerData.navLinks
            && headerData.navLinks.sectionData
            && headerData.navLinks.sectionData.reduce(createMenuItems, []))
            || [];
        var secondaryLinkMenuItems = (headerData
            && headerData.secondaryNavLinks
            && headerData.secondaryNavLinks
            && headerData.secondaryNavLinks.sectionData.reduce(createMenuItems, []))
            || [];
        var seperatorItem = [
            {
                href: undefined,
                label: undefined,
                className: 'uitk-list-divider',
                typeAnchor: false,
                attributes: {
                    role: 'separator',
                    tabindex: 0
                }
            }
        ];
        var headerImg = headerData && headerData.headerImg;
        var menuItems = [];
        if (secondaryLinkMenuItems.length === 0) {
            menuItems = navLinkMenuItems;
        }
        else if (navLinkMenuItems.length === 0) {
            menuItems = secondaryLinkMenuItems;
        }
        else {
            menuItems = navLinkMenuItems.concat(seperatorItem, secondaryLinkMenuItems);
        }
        return (React.createElement("section", { className: "header-region" },
            React.createElement("header", { className: "site-header" },
                React.createElement(UitkLayoutFlex, { alignItems: "center" },
                    React.createElement(UitkLayoutFlexItem, null,
                        React.createElement("nav", null,
                            React.createElement(HeaderMenu, { menuItems: menuItems, languages: languages }))),
                    React.createElement(UitkLayoutFlexItem, null,
                        React.createElement("div", null,
                            React.createElement(HeaderImageToolbar, { headerImg: headerImg })))),
                React.createElement(UitkLayoutFlexItem, null,
                    React.createElement("nav", { id: "secondaryNav", className: "navigation-bar", "aria-label": "secondary" },
                        React.createElement(UitkSpacing, { padding: { inlinestart: 'two' } },
                            React.createElement("div", { className: "global-nav-header-links__nav sub-header__nav" }, accountMenu && (React.createElement(HeaderAccountMenu, { analytics: analytics, page: page, l10n: l10n, position: PositionType.RIGHT, menu: accountMenuItem, menuTriggerLabelText: l10n.accountMyAccountLinkText, key: accountMenuItem.id })))))))));
    };
    HeaderMinimalToolbar = __decorate([
        inject('analytics', 'page', 'globalComponentsContext')
    ], HeaderMinimalToolbar);
    return HeaderMinimalToolbar;
}(React.Component));
export { HeaderMinimalToolbar };
//# sourceMappingURL=header-minimal-toolbar.js.map